var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-field',{attrs:{"label":_vm.$t('Provide the authentication token')}},[_c('otp-input',{ref:"otpInput",staticClass:"mfa2-input",attrs:{"input-classes":"otp-input","separator":"-","num-inputs":6,"should-auto-focus":true,"is-input-num":true},on:{"on-change":_vm.handleOnMfaChange,"on-complete":_vm.handleOnMfaComplete}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }